import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { GatsbyImage } from "./gatsby-image";
import { BadgeCheck, Search, Umbrella, DollarSign } from "lucide-react";
import cityPageContent from "../data/city-page-content";

const features = [
  { icon: BadgeCheck, label: "Licensed and Insured" },
  { icon: Search, label: "Free Estimates and Inspections" },
  { icon: Umbrella, label: "We Work With Your Insurance" },
  { icon: DollarSign, label: "Competitive Financing" },
];

const CityTrustStrip = ({ city, service }) => (
  <StaticQuery
    query={graphql`
      query {
        epa: file(relativePath: { eq: "product-badges/epa-lead-safe-white.png" }) {
          childImageSharp {
            gatsbyImageData(height: 72, placeholder: NONE)
          }
        }
        bbb: file(relativePath: { eq: "product-badges/bbb-xs.png" }) {
          childImageSharp {
            gatsbyImageData(height: 72, placeholder: NONE)
          }
        }
        nari: file(relativePath: { eq: "product-badges/nari.png" }) {
          childImageSharp {
            gatsbyImageData(height: 72, placeholder: NONE)
          }
        }
        jamesHardie: file(relativePath: { eq: "product-badges/jameshardie.png" }) {
          childImageSharp {
            gatsbyImageData(height: 72, placeholder: NONE)
          }
        }
        elite: file(relativePath: { eq: "elite-preferred.png" }) {
          childImageSharp {
            gatsbyImageData(height: 72, placeholder: NONE)
          }
        }
      }
    `}
    render={(data) => {
      const badges = [
        { key: "epa", img: getImage(data.epa.childImageSharp), alt: "EPA Lead-Safe Certified" },
        { key: "elite", img: getImage(data.elite.childImageSharp), alt: "Elite Preferred Contractor" },
        { key: "jh", img: getImage(data.jamesHardie.childImageSharp), alt: "James Hardie" },
        { key: "nari", img: getImage(data.nari.childImageSharp), alt: "NARI Member" },
        { key: "bbb", img: getImage(data.bbb.childImageSharp), alt: "BBB Accredited" },
      ];

      return (
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-display font-extrabold text-neutral-900 mb-10 md:mb-14 leading-tight">
              {cityPageContent.forPage(city, service).trustStripHeading ||
                `#1 Professional Roofing Contractor in ${String(city).trim()}, MI`}
            </h2>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mb-12 md:mb-16">
              {features.map(({ icon: Icon, label }) => (
                <div
                  key={label}
                  className="flex flex-col sm:flex-row items-center sm:items-center gap-3 text-center sm:text-left"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-50 flex items-center justify-center">
                    <Icon size={22} className="text-brand-500" strokeWidth={2.25} />
                  </div>
                  <span className="text-sm md:text-base font-semibold text-neutral-800 leading-snug">
                    {label}
                  </span>
                </div>
              ))}
            </div>

            <div className="border-t border-neutral-200 pt-10">
              <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 opacity-90">
                {badges.map(({ key, img, alt }) =>
                  img ? (
                    <div key={key} className="h-14 flex items-center">
                      <GatsbyImage
                        image={img}
                        alt={alt}
                        objectFit="contain"
                        className="max-h-14"
                      />
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </div>
        </section>
      );
    }}
  />
);

export default CityTrustStrip;
